export var CurrencyType;
(function (CurrencyType) {
    CurrencyType["RMB"] = "rmb";
    CurrencyType["USDT"] = "usdt";
})(CurrencyType || (CurrencyType = {}));
//# sourceMappingURL=CurrencyType.js.map